import branchManagementMonthlyReportComponent from "./monthly_report.component";

let branchManagementMonthlyReportModule = angular.module('branchManagementMonthlyReport', [])
    .component('branchManagementMonthlyReport', branchManagementMonthlyReportComponent)
    .name;

export default branchManagementMonthlyReportModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/monthly_report/index.js